import { message } from 'antd';

import eCoachVMSApi from '../Api';

export const getDailyServiceData = async (filterString = null) => {
    try {
        let endpoint = '/getService';
        if (filterString) {
            endpoint = `${endpoint}?${filterString}`;
        }

        const response = await eCoachVMSApi().baseURL.get(endpoint);

        return response.data;
    } catch (error) {
        console.error('Error fetching service data:', error);
        return [];
    }
};
